import { selectEnvVariables } from "../../Store/Variables/selectors";
import { useAppSelector } from "../../Store/hooks";


export const useFinalUtils = () => {

  const variables = useAppSelector(selectEnvVariables) as any;

  /**
   * Params to use in payment-result component.
   * @name paymentResultParams
  */
  const paymentResultParams = {
    titleError: variables.REACT_APP_FINAL_TITLE_ERROR || 'Error al cargar la página',
    textError: variables.REACT_APP_FINAL_TEXT_ERROR || 'No fue posible cargar la página solicitada, por favor intente otra vez.',
    highlightColor: variables.REACT_APP_ACCENT_COLOR,
  };

  return {
    paymentResultParams,
  }

}